import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Form, Icon } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { FarmerCreateOptionsType } from '~/api/services/farmers'
import { StyledFormSection } from '../style'

interface Props {
  farmerOptions: FarmerCreateOptionsType
  isLoadingOptions: boolean
}

const ManagersCertifications: React.FC<Props> = ({
  farmerOptions,
  isLoadingOptions
}) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  return (
    <StyledFormSection>
      <div className='section-header'>
        <Icon name='users' />
        <span className='section-title'>{t('Managers & Certifications')}</span>
      </div>
      <div className='section-content'>
        <Form.Group widths={'equal'}>
          <FormFields.Select
            control={control}
            disabled={isLoadingOptions}
            search
            rules={{
              required: t('Please select manager')
            }}
            placeholder={t('Select manager')}
            multiple
            label={t('Assigned Managers')}
            name={'managers'}
            options={farmerOptions?.managers?.map(manager => ({ value: manager.id, text: `${manager.name} ${manager.agisId ? `(${manager.agisId})` : ''}` })) || []}
          />
          <FormFields.Select
            control={control}
            rules={{
              required: t('Please select certification')
            }}
            placeholder={t('Please select certification')}
            label={t('Certifications')}
            name={'certifications'}
            multiple
            options={farmerOptions?.certifications?.map(certification => ({ value: certification.id, text: certification.name })) || []}
          />
          <FormFields.Select
            control={control}
            rules={{
              required: t('Please select contract type')
            }}
            placeholder={t('Please select contract type')}
            label={t('Contract Type')}
            name={'contractTypeId'}
            options={farmerOptions?.contractTypes?.map(contractType => ({ value: contractType.id, text: contractType.label })) || []}
          />
        </Form.Group>
      </div>
    </StyledFormSection>
  )
}

export default ManagersCertifications
